import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { CustomerReportingUsageWarningService } from '../../services/customer-reporting-usage-warning.service';

@Component({
  selector: 'app-data-usage-warning',
  templateUrl: './data-usage-warning.component.html',
  styleUrls: ['./data-usage-warning.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DataUsageWarningComponent implements OnInit {
  dontShowAgain = false;
  isDismissed = false;
  isHidden = true;

  constructor(
    private customerReportingUsageWarningService: CustomerReportingUsageWarningService,
  ) {}

  ngOnInit(): void {
    this.isHidden = this.customerReportingUsageWarningService.currentWarning;
  }

  dismiss(): void {
    if (this.dontShowAgain) {
      this.customerReportingUsageWarningService.setHideWarning(true);
    }
    this.isDismissed = true;
  }

  onCheckboxChange(event: CustomEvent): void {
    this.dontShowAgain = event.detail.checked;
  }
}
